import { styled } from 'troyfe'

const MenuCord = styled.div`
  background: #fff;
  box-shadow: 0 0 2px #087818;
  width: 220px;
  height: 223px;
  padding: 16px 16px 0;
  position: absolute;
  right: 0px;
  .user {
    display: flex;
    align-items: center;

    h1 {
      color: #1b1b1d;
      font-size: 16px;
      height: fit-content;
    }

    img {
      width: 40px;
      height: 40px;
      border-radius: 4px;
    }

    .user-inf {
      margin-left: 12px;
    }

    .username {
      width: 136px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #1b1b1d;
      padding: 0px 5px;
      margin-top: 4px;
      border-radius: 4px;
      font-size: 10px;
      text-align: center;
      background-color: rgb(241, 242, 244);
    }
  }

  ul {
    margin-top: 14px;

    li {
      height: 48px;
      line-height: 48px;
      text-align: left;
      cursor: pointer;
      width: 100%;
      font-size: 12px;
      border-top: 1px solid #f1f2f4;

      &:hover {
        background: rgb(240, 242, 245);
      }

      .downloadIcon {
        margin-left: 60px;
      }
    }

    .signOut {
      color: #f05e2e;
    }
  }
`

const DrawerStyle = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;

  .drawer-top {
    padding: 21px 0;
    border-bottom: 1px solid #f1f2f4;
    h1 {
      text-align: center;
      color: #333333;
      font-size: 18px;
      font-weight: 540;
      position: relative;
    }
    .clear {
      position: absolute;
      right: 32px;
      top: 0;
      font-size: 16px;
      width: 22px;
      cursor: pointer;
      font-weight: 500;
      transform: scale(1.4);
    }
  }
  .drawer-content {
    flex: 1;
    .form {
      width: 74%;
      margin: 40px auto;
      .star {
        position: relative;
        &::after {
          position: absolute;
          left: 7%;
          top: 20px;
          display: inline-block;
          color: #ff4d4f;
          font-size: 14px;
          font-family: SimSun, sans-serif;
          line-height: 1;
          content: '*';
        }
      }
    }
  }

  /* 提交按钮 */
  .handle {
    width: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    border-top: 1px solid #f1f2f4;
    padding: 15px 0;
  }
  .cancel,
  .confirm {
    width: 120px;
    height: 52px;
  }
  .cancel {
    background: #fff;
    border: 1px solid #44bb55;
    color: #44bb55;
  }
  .confirm {
    background-color: #44bb55;
    border-color: #44bb55;
    margin-left: 20px;
    color: #fff;
  }
`
export { MenuCord, DrawerStyle }
